import React, { useState, useEffect } from "react";
import { useForm } from "react-hook-form";
import { useSelector, useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";

import { useParams } from "react-router-dom";

import logo from "../../assets/img/EHN-Online-Logo.png";

import {
  canUserResetPassword,
  resetPassword,
  changeUserLang,
} from "../../actions/account.action";

import notification from "../../services/notification-service";
import localizationService from "../../services/localization-service";
import isLength from "validator/lib/isLength";
import matches from "validator/lib/matches";
import MoonLoader from "react-spinners/MoonLoader";

export const ResetPasswordPage = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const selectedlang = useSelector((state) => state.account.lang);

  let { email, guid, lang } = useParams();

  const [userCanResetPassword, setUserCanResetPassword] = useState(true);

  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setConfirmPassword] = useState(false);

  const [passLengthError, setPassLengthError] = useState(false);
  const [upperLowerCaseError, setUpperLowerCaseError] = useState(false);
  const [numberSymbolError, setNumberSymbolError] = useState(false);
  const [passwordsDontMatch, setPasswordsDontMatch] = useState(false);

  const [passwordValue, setpasswordValue] = useState("");
  const [confirmPasswordValue, setconfirmPasswordValue] = useState("");
  const [isSubmitted, setIsSubmitted] = useState(false);

  const forgotPasswordSubmiting = useSelector(
    (state) => state.account.forgotPasswordSubmiting,
  );

  useEffect(() => {
    changeLang(lang);

    onCheckPaswordReset();
  }, []);

  const onCheckPaswordReset = () => {
    dispatch(canUserResetPassword(email, guid))
      .then(() => {
        setUserCanResetPassword(true);
      })
      .catch((error) => {
        notification.error(error);
        setUserCanResetPassword(false);
      });
  };

  const updateInputValue = (value) => {
    setpasswordValue(value);

    if (isSubmitted) {
      if (!isLength(value, { min: 8, max: 16 })) {
        setPassLengthError(true);
      } else {
        setPassLengthError(false);
      }
      if (!matches(value, /(?=.*[A-Z])/) || !matches(value, /(?=.*[a-z])/)) {
        setUpperLowerCaseError(true);
      } else {
        setUpperLowerCaseError(false);
      }
      if (!matches(value, /[0-9]/) || !matches(value, /(?=.*[!@#$%^&])/)) {
        setNumberSymbolError(true);
      } else {
        setNumberSymbolError(false);
      }
    }
  };

  const checkIfPasswordsMatch = (passValue, confirmPassValue) => {
    setconfirmPasswordValue(confirmPassValue);
    if (isSubmitted) {
      if (passValue !== confirmPassValue) {
        setPasswordsDontMatch(true);
      } else {
        setPasswordsDontMatch(false);
      }
    }
  };

  const {
    handleSubmit,
    register,
    formState: { errors },
  } = useForm();
  const onSubmit = (values) => {
    setIsSubmitted(true);

    let isError = false;
    if (!isLength(values.password, { min: 8, max: 16 })) {
      setPassLengthError(true);
      isError = true;
    } else {
      setPassLengthError(false);
    }
    if (
      !matches(values.password, /(?=.*[A-Z])/) ||
      !matches(values.password, /(?=.*[a-z])/)
    ) {
      setUpperLowerCaseError(true);
      isError = true;
    } else {
      setUpperLowerCaseError(false);
    }
    if (
      !matches(values.password, /[0-9]/) ||
      !matches(values.password, /(?=.*[!@#$%^&])/)
    ) {
      setNumberSymbolError(true);
      isError = true;
    } else {
      setNumberSymbolError(false);
    }
    if (values.password !== values.confirmPassword) {
      setPasswordsDontMatch(true);
      isError = true;
    } else {
      setPasswordsDontMatch(false);
    }

    if (isError) {
      return;
    }

    dispatch(resetPassword(email, values.password, guid))
      .then(() => {
        notification.success(
          localizationService.getLocalizationValue(
            "passwordSuccesfullyChanged",
            selectedlang,
          ),
        );
        navigate("/login");
      })
      .catch((error) => {
        notification.error(error);
      });
  };

  const changeLang = (lang) => {
    dispatch(changeUserLang(lang));
  };

  return (
    <section className="min-h-screen bg-gradient-to-br from-gray-50 to-gray-100 flex items-center justify-center p-4">
      {forgotPasswordSubmiting && (
        <div className="fixed inset-0 bg-black bg-opacity-50 z-50 flex items-center justify-center">
          <MoonLoader color="#9aa82d" size={80} loading />
        </div>
      )}

      <div className="w-full max-w-md bg-white rounded-2xl shadow-xl p-8 space-y-6 text-left">
        {/* Language Toggle */}
        <div className="flex justify-end space-x-2 text-sm">
          <button
            type="button"
            onClick={() => changeLang("en-CA")}
            className={`${
              selectedlang === "en-CA"
                ? "text-primary font-medium"
                : "text-gray-400 hover:text-gray-600"
            }`}
          >
            EN
          </button>
          <span className="text-gray-300">|</span>
          <button
            type="button"
            onClick={() => changeLang("fr-CA")}
            className={`${
              selectedlang === "fr-CA"
                ? "text-primary font-medium"
                : "text-gray-400 hover:text-gray-600"
            }`}
          >
            FR
          </button>
        </div>

        {userCanResetPassword ? (
          <form onSubmit={handleSubmit(onSubmit)} className="space-y-6">
            <div className="flex justify-center">
              <img src={logo} alt="Logo" className="w-auto" />
            </div>

            <h1 className="text-2xl font-semibold text-center text-gray-900">
              {localizationService.getLocalizationValue(
                "setPasswordTitle",
                selectedlang,
              )}
            </h1>

            {/* Password Rules */}
            <p className="text-sm text-gray-600">
              {localizationService.getLocalizationValue(
                "validationMainText",
                selectedlang,
              )}
            </p>

            <ul className="text-sm space-y-1">
              <li className="flex items-center">
                <span
                  className={`h-2 w-2 rounded-full mr-2 ${
                    passLengthError ? "bg-red-500" : "bg-[#b2c235]"
                  }`}
                />
                <span
                  className={passLengthError ? "text-red-500" : "text-gray-700"}
                >
                  {localizationService.getLocalizationValue(
                    "validationLength",
                    selectedlang,
                  )}
                </span>
              </li>
              <li className="flex items-center">
                <span
                  className={`h-2 w-2 rounded-full mr-2 ${
                    upperLowerCaseError ? "bg-red-500" : "bg-[#b2c235]"
                  }`}
                />
                <span
                  className={
                    upperLowerCaseError ? "text-red-500" : "text-gray-700"
                  }
                >
                  {localizationService.getLocalizationValue(
                    "validationUpperAndLowerCase",
                    selectedlang,
                  )}
                </span>
              </li>
              <li className="flex items-center">
                <span
                  className={`h-2 w-2 rounded-full mr-2 ${
                    numberSymbolError ? "bg-red-500" : "bg-[#b2c235]"
                  }`}
                />
                <span
                  className={
                    numberSymbolError ? "text-red-500" : "text-gray-700"
                  }
                >
                  {localizationService.getLocalizationValue(
                    "validationNumberAndSymbol",
                    selectedlang,
                  )}
                </span>
              </li>
              {passwordsDontMatch && (
                <li className="text-red-500">
                  {localizationService.getLocalizationValue(
                    "passAndConfirmPassDontMatch",
                    selectedlang,
                  )}
                </li>
              )}
            </ul>

            {/* Password Input */}
            <div className="relative">
              <input
                type={showPassword ? "text" : "password"}
                className="w-full px-4 py-3 rounded-lg border border-gray-300 focus:ring-2 focus:ring-primary focus:border-transparent"
                placeholder={localizationService.getLocalizationValue(
                  "newPassword",
                  selectedlang,
                )}
                {...register("password")}
                value={passwordValue}
                onChange={(e) => {
                  updateInputValue(e.target.value);
                  checkIfPasswordsMatch(e.target.value, confirmPasswordValue);
                }}
              />
              <button
                type="button"
                onClick={() => setShowPassword(!showPassword)}
                className="absolute right-3 top-1/2 -translate-y-1/2 text-gray-400 hover:text-gray-600"
              >
                <i
                  className={`fa ${showPassword ? "fa-eye" : "fa-eye-slash"}`}
                />
              </button>
            </div>

            {/* Confirm Password Input */}
            <div className="relative">
              <input
                type={showConfirmPassword ? "text" : "password"}
                className="w-full px-4 py-3 rounded-lg border border-gray-300 focus:ring-2 focus:ring-primary focus:border-transparent"
                placeholder={localizationService.getLocalizationValue(
                  "confirmPassword",
                  selectedlang,
                )}
                {...register("confirmPassword")}
                value={confirmPasswordValue}
                onChange={(e) =>
                  checkIfPasswordsMatch(passwordValue, e.target.value)
                }
              />
              <button
                type="button"
                onClick={() => setConfirmPassword(!showConfirmPassword)}
                className="absolute right-3 top-1/2 -translate-y-1/2 text-gray-400 hover:text-gray-600"
              >
                <i
                  className={`fa ${
                    showConfirmPassword ? "fa-eye" : "fa-eye-slash"
                  }`}
                />
              </button>
            </div>

            <button
              type="submit"
              className="w-full py-3 px-4 bg-[#9aa82d] hover:bg-[#7d8a1f] text-white font-medium rounded-lg text-sm uppercase"
            >
              {localizationService.getLocalizationValue(
                "resetPasswordSubmitBtn",
                selectedlang,
              )}
            </button>
          </form>
        ) : (
          <form className="space-y-6">
            <div className="flex justify-center">
              <img src={logo} alt="Logo" className="w-auto" />
            </div>
            <h1 className="text-2xl font-semibold text-center text-gray-900">
              {localizationService.getLocalizationValue(
                "usedLink",
                selectedlang,
              )}
            </h1>
          </form>
        )}

        <p className="text-center text-sm text-gray-500 mt-4">
          &copy; 2025 onthewagon.ca.{" "}
          {localizationService.getLocalizationValue(
            "rightsReserved",
            selectedlang,
          )}
          .
        </p>
      </div>
    </section>
  );
};
